import { ChildInfoResponse } from "./api";

export enum actions {
  saveDonorInfo = "SAVE_DONOR_INFO",
  saveDonationInfo = "SAVE_DONATION_INFO",
}

export type AppState = {
  donorInfo: {
    name: string;
    email: string;
    phone: string;
  };
  donation: {
    id: string;
    child: ChildInfoResponse;
  };
};

export const initialAppState: AppState = {
  donorInfo: { name: "", email: "", phone: "" },
  donation: null,
};

export function appReducer(state: AppState, { type, payload }): AppState {
  switch (type) {
    case actions.saveDonorInfo:
      return {
        ...state,
        donorInfo: payload,
      };
    case actions.saveDonationInfo:
      return {
        ...state,
        donation: payload,
      };

    default:
      throw new Error("invalid action dispatched");
  }
}
